import Popover from 'src/components/popover/popover.vue'
import UserListRow from 'src/components/user_list_row/user_list_row.vue'

import { useUsersStore } from 'src/stores/users.js'

// who favorited, repeated, reacted or quoted, on hover: the first sixteen,
// and a link to the full list (see ParticipantsDialog) when there are more
const UserListPopover = {
  name: 'UserListPopover',
  props: {
    userIds: { type: Set, default: () => new Set() },
    load: Function,
    needsLoad: Boolean,
    // the server has a further page (quotes)
    hasMore: Boolean,
    // which list this is, for the full list
    category: String,
  },
  inject: {
    openParticipants: { default: null },
  },
  components: {
    Popover,
    UserListRow,
  },
  data: () => ({
    loading: false,
    loaded: false,
    failed: false,
  }),
  computed: {
    users() {
      return [...this.userIds]
        .map((id) => useUsersStore().findUser(id))
        .filter(Boolean)
    },
    usersCapped() {
      return this.users.slice(0, 16)
    },
    moreShown() {
      return (
        !!this.openParticipants &&
        !!this.category &&
        (this.users.length > 16 || this.hasMore)
      )
    },
  },
  methods: {
    openAll() {
      const trigger = this.$refs.popover?.$refs.trigger
      this.openParticipants(this.category, trigger)
    },
    async loadUsers(retry = false) {
      if (
        !this.load ||
        this.loading ||
        (!retry && (this.failed || this.loaded))
      )
        return
      if (!retry && !this.needsLoad && this.users.length === this.userIds.size)
        return
      this.loading = true
      this.failed = false
      try {
        // False means discarded (a reset or click race), so a later hover retries.
        this.loaded = (await this.load()) !== false
      } catch {
        this.failed = true
      } finally {
        this.loading = false
      }
    },
  },
}

export default UserListPopover
